import { useSocialData } from "./useSocialData";

export { useSocialData };
